import { makeAutoObservable } from "mobx";
import { IBrowseByCollection, IMerchantCollection } from "../models/User";

class BrowseByCollectionStore {
    private _model: IBrowseByCollection = {
        is_browse_by_collection_active: false,
        collection_titles: '',
    };
    private _changes: IBrowseByCollection = {
        is_browse_by_collection_active: false,
        collection_titles: '',
    };
    private _invalidTitles: string = '';

    constructor(is_browse_by_collection_active: boolean, merchant_collections: IMerchantCollection[]) {
        makeAutoObservable(this, {}, { autoBind: true });
        const collection_titles = merchant_collections
            ?.map(collection => collection.title)
            ?.join(', ') ?? '';
        this._invalidTitles = merchant_collections
            ?.filter(collection => !collection.id)
            ?.map(collection => collection.title)
            ?.join(', ') ?? '';

        this.setModel({
            is_browse_by_collection_active: is_browse_by_collection_active ?? false,
            collection_titles,
        });

        this.discardChanges();
    }

    private setModel(model: IBrowseByCollection) {
        this._model = model;
    }

    public hasChanges() {
        return JSON.stringify(this._changes) !== JSON.stringify(this._model);
    }

    public getUpdatedModel(): IBrowseByCollection {
        return { ...this._model, ...this._changes };
    }

    public discardChanges(): void {
        this._changes = JSON.parse(JSON.stringify(this._model));
    }

    public get collectionTitles(): string {
        return this._changes.collection_titles ?? '';
    }

    public get invalidTitles(): string {
        return this._invalidTitles ?? '';
    }

    public setIsBrowseByCollectionActive(value: boolean) {
        this._changes.is_browse_by_collection_active = value;
    }

    public setCollectionTitles(value: string) {
        this._changes.collection_titles = value;
    }
}

export default BrowseByCollectionStore;
